var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const jsonHeader = () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    return headers;
};
export const affiliateApi = (config) => {
    var _a;
    const affiliateUrl = (_a = config === null || config === void 0 ? void 0 : config.affiliateUrl) !== null && _a !== void 0 ? _a : window.location.origin;
    const client = config.client;
    const headers = jsonHeader();
    return {
        create: (awc) => __awaiter(void 0, void 0, void 0, function* () {
            if (!awc)
                return;
            const resp = yield fetch(`${affiliateUrl}/affiliate/api/awin?client=${client}`, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify({ awc: awc }),
                headers,
            });
            if (resp.status !== 200)
                throw new Error(`Bad response from affiliate: ${resp.status}`);
        }),
        complete: (reference, amount, commissionGroup) => __awaiter(void 0, void 0, void 0, function* () {
            if (!reference || !amount)
                return;
            const resp = yield fetch(`${affiliateUrl}/affiliate/api/awin?client=${client}`, {
                method: "PUT",
                credentials: "include",
                body: JSON.stringify({ commissionGroup, reference, amount }),
                headers,
            });
            if (resp.status !== 200)
                throw new Error(`Bad response from affiliate: ${resp.status}`);
        }),
    };
};
